import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
  text-align: center;
`;

export const Title = styled.h1`
  font-family: 'Inter Medium';
  font-weight: 800;
  font-size: 24px;
  line-height: 33px;
  margin-top: 21px;
`;

export const Description = styled.p`
  font-family: 'Inter Regular';
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  color: ${(props) => props.theme.colors.greyLetter};
  margin: 32px 0;
`;
